import { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faCheck,
  faEye,
  faEyeSlash,
} from "@fortawesome/pro-solid-svg-icons";

export interface SigningSecretProps {
  value?: string | null;
}

const PREFIX = "whsec_";
// Fixed length so the mask does not reveal the real secret's length.
const MASK = `${PREFIX}${"•".repeat(32)}`;

export const SigningSecret = ({
  value,
}: SigningSecretProps): JSX.Element | null => {
  const [revealed, setRevealed] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div data-testid="signing-secret" style={{ marginTop: "24px" }}>
      <label style={{ fontWeight: 600, display: "block", marginBottom: "4px" }}>
        Signing secret
      </label>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <code
          data-testid="signing-secret-value"
          style={{
            flex: 1,
            padding: "8px",
            background: "#f5f5f5",
            borderRadius: "4px",
            overflowX: "auto",
            fontFamily: "monospace",
          }}
        >
          {revealed ? value : MASK}
        </code>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => setRevealed((r) => !r)}
        >
          <FontAwesomeIcon icon={revealed ? faEyeSlash : faEye} />{" "}
          {revealed ? "Hide" : "Show"}
        </Button>
        <Button variant="outline-secondary" size="sm" onClick={handleCopy}>
          <FontAwesomeIcon icon={copied ? faCheck : faCopy} />{" "}
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>
      <small className="text-muted">
        Receivers use this secret to verify the <code>webhook-signature</code>{" "}
        header on each delivery.
      </small>
    </div>
  );
};
